import React from 'react';

import { Box, Typography, CircularProgress, styled } from '@mui/material';

const CenteredBox = styled(Box)({
  textAlign: 'center',
});

const LoadingBox = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  marginBottom: 3,
});

export const ExportLoadingState = () => {
  return (
    <CenteredBox sx={{ py: 4 }}>
      <LoadingBox>
        <CircularProgress size={40} />
      </LoadingBox>
      <Typography variant="body1">
        GruntWorx export started.
      </Typography>
    </CenteredBox>
  );
}; 